import { Box, BoxProps, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { CurrencyLabel, DateDisplay, RevisionApprovalTable } from 'features';
import { useState } from 'react';
import { DecisionDrawer, DecisionDrawerProps } from './DecisionDrawer';
import { AfeTransactionSummaryResponse } from 'api/bindings/AfeTransactionSummaryResponse';
import { PurchaseOrderTransactionSummaryResponse } from 'api/bindings/PurchaseOrderTransactionSummaryResponse';
import { WorkOrderTransactionSummaryResponse } from 'api/bindings/WorkOrderTransactionSummaryResponse';
import { InvoiceTransactionSummaryResponse } from 'api/bindings/InvoiceTransactionSummaryResponse';

type AnyTransaction =
  | AfeTransactionSummaryResponse
  | PurchaseOrderTransactionSummaryResponse
  | WorkOrderTransactionSummaryResponse
  | InvoiceTransactionSummaryResponse;

export interface ApproversSectionProps<T extends AnyTransaction>
  extends BoxProps {
  entityName: string;
  revision: T | undefined;
  onDecision?: () => void;
}

export const ApproversSection = <T extends AnyTransaction>(
  props: ApproversSectionProps<T>
) => {
  const { entityName, revision, onDecision, ...rest } = props;

  const [modal, setModal] = useState<Omit<DecisionDrawerProps, 'onClose'>>();

  return (
    <Box {...rest}>
      {modal && (
        <DecisionDrawer
          {...modal}
          onDecision={onDecision}
          onClose={() => setModal(undefined)}
        />
      )}
      <Stack gap={4}>
        <SimpleGrid columns={[2, 4]} gap={[2, 4]}>
          <Text as="b">Total:</Text>
          <CurrencyLabel value={revision?.total} />
          <Text as="b">Requested:</Text>
          <DateDisplay value={revision?.requested} />
        </SimpleGrid>
        <RevisionApprovalTable
          approvals={revision?.approvals}
          onDecisionRequested={(a) =>
            setModal({
              entityId: a.entityId,
              entityName: entityName,
              revisionName: revision?.name ?? '',
              transactionId: revision?.transactionId ?? "0",
              transactionType: revision?.transactionType ?? 0,
              isOpen: true,
              amount: revision?.total ?? '0',
              ownerId: a.userId,
            })
          }
        />
      </Stack>
    </Box>
  );
};
